import { overview as AT } from './AT';
import { overview as CZ } from './CZ';
import { overview as HR } from './HR';
import { overview as HU } from './HU';
import { overview as RO } from './RO';
import { overview as SK } from './SK';
import { overview as RS } from './RS';

export const featureMap = {
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
    RS,
};
